import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { postApi, ApiResponse } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { IRequestWithHeader, Types } from './types';

// ACTIONS
import {
	emitirTransferenciasMunicipiosEstadosSuccess,
	emitirTransferenciasMunicipiosEstadosFailure,
} from './actions';

function* emitirAutorizacaoPreviaRequest(request: ReducerAction) {
	const { payload }: { payload: IRequestWithHeader } = request;
	const { body, headers } = payload;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/emissao/transferencias-municipios-estados`,
		body,
		headers,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(
			emitirTransferenciasMunicipiosEstadosSuccess(
				response.data.resultadoTransferencia,
			),
		);
	} else if (response.error) {
		yield put(emitirTransferenciasMunicipiosEstadosFailure());
	}
}

export default all([
	takeLatest(
		Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_ESTADOS_REQUEST,
		emitirAutorizacaoPreviaRequest,
	),
]);
